import Vue from 'vue';
import Vuex from 'vuex';

import backend from './backend';
import user from './user';
import ui from './ui';
import data from './data';
import basket from './basket';
import theme from './theme';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  modules: { backend, ui, user, theme, data, basket },
  state: {},
  mutations: {},
  actions: {},
});
